import { render, staticRenderFns } from "./EventsIndexSearch.vue?vue&type=template&id=28d7ed73&"
import script from "./EventsIndexSearch.vue?vue&type=script&lang=js&"
export * from "./EventsIndexSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports